import e from"react";import t from"./Modal.less.js";var a=function(a){var r=a.className,c=a.style,o=a.children;return e.createElement("div",{className:"".concat(t["modal-content"]," ").concat(r),style:c},o)};export{a as ModalContent};
//# sourceMappingURL=ModalContent.js.map
